import { render, staticRenderFns } from "./W.vue?vue&type=template&id=4bfd1abe&scoped=true&"
import script from "./W.vue?vue&type=script&lang=js&"
export * from "./W.vue?vue&type=script&lang=js&"
import style0 from "./W.vue?vue&type=style&index=0&id=4bfd1abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd1abe",
  null
  
)

export default component.exports